export function mergeIntoObjectByDescriptors(a, b, options) {
    var propertyDescriptorMap = Object.getOwnPropertyDescriptors(b);
    if (options) {
        if (options.configurable === true || options.configurable === false) {
            Object.values(propertyDescriptorMap).forEach(function (desc) { return desc.configurable = options.configurable; });
        }
    }
    Object.defineProperties(a, propertyDescriptorMap);
    return a;
}
export function copyWithJSON(obj) {
    if (obj === undefined || obj === null)
        return obj;
    return JSON.parse(JSON.stringify(obj));
}
